import { render, staticRenderFns } from "./JLoading.vue?vue&type=template&id=1874c0c0&"
import script from "./JLoading.vue?vue&type=script&lang=js&"
export * from "./JLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports